import React from 'react'
import { RouteComponentProps, Route } from 'react-router'
import { Switch } from 'react-router-dom'
import StockUpdate from './stock-update/stock-update'
import StockReduce from './stock-reduce/stock-reduce'
import StockSearch from './stock-search/stock-search'
import StockJoin from './stock-join/stock-join'
import StockReturn from './stock-return-purchase/stock-return-purchase'

const path = '/main/goods/stockManage'

export const GOODS_JOIN_STOCK = path + '/join'
export const GOODS_SEARCH_STOCK = path + '/search'
export const GOODS_UPDATE_STOCK = path + '/update'
export const GOODS_REDUCE_STOCK = path + '/reduce'
export const GOODS_RETURN_PURCHASE = path + '/returnPurchase'

export default (props: RouteComponentProps) => {
    return (
        <Switch>
            <Route path={props.match.path + '/update'} component={StockUpdate}></Route>
            <Route path={props.match.path + '/reduce'} component={StockReduce}></Route>
            <Route path={props.match.path + '/search'} component={StockSearch}></Route>
            <Route path={props.match.path + '/join'} component={StockJoin}></Route>
            <Route path={props.match.path + '/returnPurchase'} component={StockReturn}></Route>
        </Switch>
    )
}
